// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    CATEGORY_PAGE_LOADING() {
      return {
        isLoading: true,
        categoryPage: action.categoryPage
      };
    },
    CATEGORY_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const category = get(currentState, 'categoryFeaturedFeed.category.slug');
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        category,
        'categoryPage'
      );

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    CATEGORY_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.categoryPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
